import * as React from 'react';
import { styled } from '../../common.styles';
import { Flex } from '../layout/general/layout';
import { AdminScaleLoader, ScaleLoader } from './scale-loader';
import { css } from 'styled-components';

export const LoaderContainer = styled(Flex)`
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const ModuleLoaderContainer = styled(LoaderContainer)`
  height: 800px;
`;

const AdjustableContainer = styled(LoaderContainer)<{ height?: number }>`
  height: 200px;
  justify-content: center;
  align-items: center;
  ${(p) =>
    p.height &&
    css`
      height: ${p.height}px;
    `};
`;

export const DWTLoading = () => <></>;

export const AdminDWTLoading = () => (
  <LoaderContainer>
    <AdminScaleLoader />
  </LoaderContainer>
);

export const DWTModuleLoading = () => (
  <ModuleLoaderContainer>
    <ScaleLoader />
  </ModuleLoaderContainer>
);

export const DWTLoadingAdjustable = (height?: number) => (
  <AdjustableContainer height={height}>
    <ScaleLoader />
  </AdjustableContainer>
);
